import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DeleteUpiUseCase extends BaseUseCase {
    constructor(deleteUpiRep) {
        super();
        this.deleteUpiRep = deleteUpiRep;
    }
    async fetchResult(req) {
        return await this.deleteUpiRep.deleteUpiData(req);
    }
}
export default DeleteUpiUseCase;
